<template>
  <v-app-bar class="top-strip-box-shadow" color="white" height="76" fixed flat>
    <v-row align="center" no-gutters>
      <v-col cols="3" sm="3" md="3" lg="2">
        <v-row no-gutters>
          <v-col class="d-flex justify-space-around">
            <router-link
              v-if="authorized"
              :to="{
                name: 'account',
                hash: '#profile',
                params: { view: 'My Profile' },
              }"
            >Account
            </router-link
            >
            <LoginButton v-else />
            <router-link
              v-if="authorized && includeLoyalty && (hasClubs || hasPoints)"
              :to="{ name: 'account', hash: '#rewards' }"
            >
              <v-tooltip nudge-right="80px"  max-width="180px" bottom color="secondary">
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="($route.hash != '#rewards' && rewardsAvailable) ? on : null"
                    class="d-flex align-center"
                  >
                    <Icon
                      name="crownrewards"
                      color="var(--v-secondary-base)"
                      :style="{ height: '20px', width: '20px' }"
                    ></Icon>
                    <span style="color: var(--v-secondary-base); margin-left: 5px">
                      Rewards
                    </span>
                  </div>
                </template>
                <span>You have rewards! Click Rewards to get your free stuff!</span>
              </v-tooltip>
            </router-link>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" sm="6" md="6" lg="8">
        <v-row no-gutters>
          <v-col>
            <slot></slot>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" sm="3" md="3" lg="2">
        <v-row align="center" no-gutters>
          <v-col class="align-center d-flex justify-end">
            <!--
            <router-link class="d-sm-none d-md-inline" :to="{ name: 'about'}">About</router-link>
            -->
            <CartButton class="mr-3" />
            <Badge />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
import Badge from "@/components/UI/Badge.vue";
import CartButton from "@/components/Auth/Buttons/Cart.vue";
import LoginButton from "@/components/Auth/Buttons/Login.vue";
import Icon from "@/components/UI/Icon.vue";

export default {
  name: "TopStrip",
  components: { Icon, Badge, CartButton, LoginButton },
  computed: {
    ...mapGetters("auth", { authorized: "isAuthenticated" }),
    ...mapGetters("store", {
      hasPoints: "hasPoints",
      hasClubs: "hasClubs",
      rewardsAvailable: "rewardsAvailable",
    }),
  },
  data() {
    return {
      includeLoyalty:
        process.env.VUE_APP_INCLUDE_LOYALTY.toLowerCase() === "true",
    };
  },
};
</script>

<style scoped>
.top-strip-box-shadow {
  box-shadow: inset 0 -1px 0 0 #dadada;
}
</style>
